import * as React from 'react';
import { connect } from 'react-redux';

import Header from '../static/Header';
import {OpenWebLayout} from '../static/Layouts';
import OpenWebGrid from './OpenWebGrid';
import {
  getOpenWeb,
  getOpenWebs,
  postOpenWebs,
} from '../../data/openweb/openwebActions';

class OpenWeb extends React.Component {

  /** ----- lifecycle methods -----*/
  constructor(props){
    super(props);
  }

  componentDidMount() {
    const {getOpenWebs} = this.props;
    getOpenWebs();
  }

  /* ------------ rendering ------------ */

  render () {

    const {
      getOpenWebs,
      getOpenWeb,
      openwebs,
      postOpenWebs,
      canStart,
    } = this.props;

    const user = "system";

    return (
      <OpenWebLayout>
        <Header top>
        </Header>
        <OpenWebGrid getOpenWeb={getOpenWeb} openwebs={openwebs} postOpenWebs={postOpenWebs} canStart={canStart} getOpenWebs={getOpenWebs} user={user}/>
      </OpenWebLayout>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    openwebs: state.openweb.openweb_cache,
    canStart: state.openweb.can_start_run,
  }
};

export default connect(mapStateToProps, {
  getOpenWebs,
  getOpenWeb,
  postOpenWebs,
})(OpenWeb);



// WEBPACK FOOTER //
// ./src/components/OpenWeb/OpenWeb.js